import React from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  Title,
  StyledLine,
  StyledLineInside,
  Links
} from '../StyledComponents';

const RelatedArticles = props => {
  const { relatedArticlesData } = props;

  let links = relatedArticlesData.map(article => (
    <li style={{ margin: '0.5rem 0' }} key={article.id}>
      <Link
        className="pa1"
        // to={article.postSlug}
        to={{ pathname: `${article.postSlug}`, state: 'change' }}
      >
        {article.postName}
      </Link>
    </li>
  ));

  return (
    <Card direction="column" border="none" padding="20px" background="#f6f6f6">
      <Title fontFamily="Montserrat" fontSize="1.5rem" fontWeight="500">
        Related Articles
      </Title>
      <StyledLine>
        <StyledLineInside />
      </StyledLine>
      <Links
        className="Related Article Link"
        direction="column"
        family="Nunito"
        size="1.125rem"
        lineheight="normal"
        color="#4db2ec"
      >
        <ul style={{ margin: '0', color: '#4db2ec' }}>{links}</ul>
      </Links>
    </Card>
  );
};

export default RelatedArticles;
